import {debounce} from 'lodash'
import {useEffect, useRef, useState} from 'react'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import Paginator from '../../../custom/Paginator'
import Loader from '../../../custom/loader/Loader'
import {Dropdown, DropdownButton} from 'react-bootstrap'
import {useAppDispatch} from '../../../../redux/hooks'
import {getUsers, deleteUser} from '../../../../redux/user/userSlice'
import {GetCampuses, StartImpersonate} from '../../../../redux/general/generalSlice'
import {encryptId} from '../../../../_metronic/helpers/Encrypt'
import NoData from '_metronic/helpers/NoData'
import {showConfirmation, showErrorMessage, showSuccessMessage} from '_metronic/helpers/swalHelper'
import {useAuth} from '../core/Auth'
import CustomSelect from 'app/custom/CustomSelect'
import {getUserByToken} from '../core/_requests'
import {getRole} from '../../../../redux/role/roleSlice'

const SORT_ASC = 'asc'
const SORT_DESC = 'desc'

const UserDataTable = (props: any) => {
  const [data, setData] = useState([])
  const [perPage, setPerPage] = useState(20)
  const [sortColumn, setSortColumn] = useState(props.columns[0])
  const [campuses, setCampuses] = useState([])
  const [sortOrder, setSortOrder] = useState('asc')
  const [search, setSearch] = useState('')
  const [email, setEmail] = useState('')
  const [campusId, setCampusId] = useState('')
  const [username, setUsername] = useState('')
  const [pagination, setPagination] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [roles, setRoles] = useState<any>([])
  const [roleId, setRoleId] = useState<any>('')
  const [loading, setLoading] = useState(true)
  const {t} = useTranslation()

  const dispatch = useAppDispatch()

  const {saveAuth, setCurrentUser, currentUser, hasPermission} = useAuth()

  const handleSort = (column: any) => {
    if (column === sortColumn) {
      sortOrder === SORT_ASC ? setSortOrder(SORT_DESC) : setSortOrder(SORT_ASC)
    } else {
      setSortColumn(column)
      setSortOrder(SORT_ASC)
    }
  }

  const handleSearch = useRef(
    debounce((query) => {
      setLoading(true)
      setSearch(query)
      setCurrentPage(1)
      setSortOrder(SORT_ASC)
      setSortColumn(props.columns[0])
    }, 500)
  ).current

  const handleEmailSearch = useRef(
    debounce((query) => {
      setLoading(true)
      setEmail(query)
      setCurrentPage(1)
      setSortOrder(SORT_ASC)
      setSortColumn(props.columns[0])
    }, 500)
  ).current

  const handleUsernameSearch = useRef(
    debounce((query) => {
      setLoading(true)
      setUsername(query)
      setCurrentPage(1)
      setSortOrder(SORT_ASC)
      setSortColumn(props.columns[0])
    }, 500)
  ).current
  const handleCampusSearch = useRef(
    debounce((query) => {
      setLoading(true)
      setCampusId(query)
      setCurrentPage(1)
      setSortOrder(SORT_ASC)
      setSortColumn(props.columns[0])
    }, 500)
  ).current

  const handleRoleSearch = useRef(
    debounce((query) => {
      setLoading(true)
      setRoleId(query)
      setCurrentPage(1)
      setSortOrder(SORT_ASC)
      setSortColumn(props.columns[0])
    }, 500)
  ).current

  const handlePerPage = (perPage: any) => {
    setLoading(true)
    setCurrentPage(1)
    setPerPage(perPage)
  }

  // Global params for pagination
  const params = {
    campusId,
    roleId,
    search,
    email,
    username,
    sort_field: sortColumn,
    sort_order: sortOrder,
    per_page: perPage,
    page: currentPage,
  }
  const listData = () => {
    dispatch(getUsers({params})).then((res) => {
      if (res.meta.requestStatus === 'fulfilled') {
        setData(res.payload.data)
        setPagination(res.payload.meta)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    listData()
    dispatch(GetCampuses()).then((res) => {
      if (res.meta.requestStatus === 'fulfilled') {
        setCampuses(res.payload)
      }
    })
    dispatch(getRole()).then((res) => {
      if (res.meta.requestStatus === 'fulfilled') setRoles(res.payload)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, email, perPage, search, username, campusId, roleId, sortColumn, sortOrder])

  const handleDelete = (user_id: any) => {
    showConfirmation(
      t('MESSAGES.CONFIRMATION'),
      t('GLOBAL.YES'),
      t('GLOBAL.NO'),
      () => {
        setLoading(true)
        dispatch(deleteUser(user_id)).then((res) => {
          if (res.meta.requestStatus === 'fulfilled') {
            showSuccessMessage(t('MESSAGES.DELETED'), () => {
              listData()
            })
          }
        })
      },
      () => showErrorMessage(t('MESSAGES.SERVER_ERROR'))
    )
  }

  const handleImpersonate = async (id: any) => {
    setLoading(true)
    sessionStorage.setItem('impersonator_id', encryptId(currentUser?.id))
    const formData = new FormData()
    formData.append('user_id', encryptId(id))
    formData.append('type', 'user')
    const res = await dispatch(StartImpersonate(formData))

    if (res.meta.requestStatus === 'fulfilled') {
      saveAuth(res.payload)
      const {data: user} = await getUserByToken(res.payload.api_token)
      setCurrentUser(user)
      setLoading(false)
      window.location.href = `/dashboard`
    } else {
      showErrorMessage(t('MESSAGES.SERVER_ERROR'))
    }
  }

  return (
    <div>
      {/* Search per page starts */}
      <div className='form'>
        <h5>{t('GLOBAL.SEARCH')}</h5>
        <div className='row mb-3'>
          <div className='row mb-8'>
            <div className='col-lg-2'>
              <input
                type='search'
                placeholder={t('GLOBAL.USERNAME')}
                className={'form-control form-control-sm'}
                onChange={(e) => handleUsernameSearch(e.target.value)}
              />
            </div>
            <div className='col-lg-2'>
              <input
                type='search'
                placeholder={t('GLOBAL.NAME')}
                className={'form-control form-control-sm'}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <div className='col-lg-2'>
              <input
                type='search'
                placeholder={t('PROFILE.EMAIL')}
                className={'form-control form-control-sm'}
                onChange={(e) => handleEmailSearch(e.target.value)}
              />
            </div>
            {hasPermission('access-to-all-campus-data') && (
              <div className='col-lg-2 col-sm-12'>
                <CustomSelect
                  className='input'
                  onChange={(e: any) => handleCampusSearch(e.id)}
                  options={campuses}
                  placeholderText={t('LABEL.CAMPUS')}
                />
              </div>
            )}
            <div className='col-lg-2 col-sm-12'>
              <CustomSelect
                className='input'
                onChange={(e: any) => handleRoleSearch(e.id)}
                options={roles}
                placeholderText={t('LABEL.ROLE')}
              />
            </div>
            <div className='col-md-2'>
              <div className='input-group'>
                <label className='mt-2 mx-1'>{t('GLOBAL.RECORD_PER_PAGE')}</label>
                <select
                  className='form-select form-select-sm'
                  value={perPage}
                  onChange={(e) => handlePerPage(e.target.value)}
                >
                  <option value='5'>5</option>
                  <option value='10'>10</option>
                  <option value='20'>20</option>
                  <option value='50'>50</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search per page ends  */}
      <div className='tableFixHead'>
        <table className='table table-bordered table-hover table-checkable data-table gy-4 gs-5'>
          <thead className='table-secondary'>
            <tr>
              {props.headers.map((header: any) => {
                return (
                  <th key={header.headerName} onClick={(e) => handleSort(header.sort)}>
                    {header.headerName.replace('_', ' ')}
                    {header.sort === sortColumn ? (
                      <span>
                        {sortOrder === SORT_ASC ? (
                          <i className='ms-1 fa fa-arrow-up' aria-hidden='true'></i>
                        ) : (
                          <i className='ms-1 fa fa-arrow-down' aria-hidden='true'></i>
                        )}
                      </span>
                    ) : null}
                  </th>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {data?.length === 0 && !loading ? <NoData Colspan={props.columns.length + 1} /> : ''}

            {!loading ? (
              data.map((user: any) => {
                return (
                  <tr key={user.id}>
                    <th className='text-center'>{user.id}</th>
                    <td>{user.username}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    {hasPermission('access-to-all-campus-data') && <td>{user.campus}</td>}
                    <td>
                      {user.user_roles.map((r: any, index: number) => (
                        <span key={index}>
                          <span className='badge badge-primary'>{r.name}</span>{' '}
                        </span>
                      ))}
                    </td>
                    <td className='text-center'>
                      <DropdownButton size='sm' title=''>
                        {user.id !== 1 && (
                          <Dropdown.Item
                            as='button'
                            onClick={() => handleImpersonate(user.id)}
                            className='text-end'
                          >
                            <i className='fas fa-sign-in text-success'></i>
                            <span className='btn btn-sm  fw-bolder'>
                              {t('BUTTONS.Login_', {name: user.name})}
                            </span>
                          </Dropdown.Item>
                        )}
                        {hasPermission('user-update') && (
                          <Dropdown.Item
                            className='text-end'
                            as={Link}
                            to={`/user-edit/${encryptId(user.id)}`}
                          >
                            <i className='fas fa-edit text-warning'></i>
                            <span className='btn btn-sm fw-bolder'>{t('BUTTONS.EDIT')}</span>
                          </Dropdown.Item>
                        )}
                        {hasPermission('user-delete') && (
                          <Dropdown.Item
                            as='button'
                            onClick={() => handleDelete(user.id)}
                            disabled={currentUser?.id === user.id}
                            className='text-end'
                          >
                            <i className='fas fa-trash text-danger'></i>
                            <span className='btn btn-sm  fw-bolder'>{t('BUTTONS.DELETE')}</span>
                          </Dropdown.Item>
                        )}
                      </DropdownButton>
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={props.columns.length + 1}>
                  <div className='d-flex justify-content-center'>{loading && <Loader />}</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {data?.length > 0 && !loading ? (
        <div className='mt-2' style={{direction: 'ltr'}}>
          <Paginator
            pagination={pagination}
            pageChanged={(page: number) => setCurrentPage(page)}
            totalItems={data.length}
            records_name={t('MENU.STAFF_USERS')}
          />
        </div>
      ) : null}
    </div>
  )
}

export default UserDataTable
